import dialog from "suneditor/src/plugins/modules/dialog";
import _ from "i18n";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import React from 'react';
import ReactDOM from 'react-dom';

export let customFillFreesection = {
  name: "customFillFreeSection",
  display: "dialog",
  title: "",
  buttonClass: "se-btn-hidden",

  // @Required
  // add function - It is called only once when the plugin is first run.
  // This function generates HTML to append and register the event.
  // arguments - (core : core object, targetElement : clicked button element)
  add: function (core) {
    core.addModule([dialog]);

    const context = core.context;

    context.customFillFreeSection = {
      _freeSectionSpan: null,
    };

    /** free section controller */
    let fs_controller = this.setController_fsButton(core);
    context.customFillFreeSection.fsController = fs_controller;
    context.customFillFreeSection._freeSectionSpan = null;

    /** add event listeners */
    fs_controller.querySelector('.se-content-btn').addEventListener("click", this.onClick_fsButtonController.bind(core));

    /** append controller */
    context.element.relative.appendChild(fs_controller);

    /** empty memory */
    fs_controller = null;
  },

  /** modify controller button */
  setController_fsButton: function (core) {
    const lang = core.lang;
    const icons = core.icons;
    const fs_btn = core.util.createElement("DIV");

    fs_btn.className = "se-controller fill-fs-container";
    fs_btn.innerHTML = `
      <div class="se-arrow se-arrow-up"></div>
      <div>
        <span class="content-text"></span>
        <div class="content-input">
        <div class="datepicker-container"></div>
      </div>
        <div class="content-btn">
        <button class="se-content-btn btn primary">${_("save")}</button>
        </div>
      </div>
    `;

    return fs_btn;
  },

  // @Override core
  // Plugins with active methods load immediately when the editor loads.
  // Called each time the selection is moved.
  active: function (element) {
    if (!element) {
      if (this.controllerArray.indexOf(this.context.customFillFreeSection.fsController) > -1) {
        this.controllersOff();
      }
    } else if (element.getAttribute("data-type") === "FREE_SECTION") {
      if (this.controllerArray.indexOf(this.context.customFillFreeSection.fsController) < 0) {
        this.plugins.customFillFreeSection.call_controller.call(this, element);
      }
      return true;
    }

    return false;
  },

  call_controller: function (selectionSpanTag) {
    this.editFs = this.context.customFillFreeSection._freeSectionSpan = selectionSpanTag;
    const fsBtn = this.context.customFillFreeSection.fsController;
    const freeSection = fsBtn.querySelector("span");

    const divInput = fsBtn.querySelector(".content-input");
    freeSection.textContent = selectionSpanTag.getAttribute("data-question");
    const fsFormat = selectionSpanTag.getAttribute("data-format");
    let inputDate =  new Date();
    function handleDateChange(date) {
      const divDatePicker = divInput.querySelector(".datepicker-container");
      ReactDOM.render(
        <DatePicker  selected={date} onChange={(date) => handleDateChange(date)}
                     timeInputLabel="Time:"
                     dateFormat="dd/MM/yyyy h:mm aa"
                     className="datepicker"
                     showTimeInput/>,
        divDatePicker
      );
    }

    switch (fsFormat) {
      case "DATE":
        divInput.innerHTML = `<div class="datepicker-container"></div>`;
        const divDatePicker = divInput.querySelector(".datepicker-container");

        ReactDOM.render(
          <DatePicker selected={inputDate} onChange={(date) => handleDateChange(date)}
                       timeInputLabel="Time:"
                       dateFormat="dd/MM/yyyy h:mm aa"
                       className="datepicker"
                       showTimeInput/>,
            divDatePicker
        );
        break;
      case "TEXT":
        divInput.innerHTML = `<textarea class="fs-textarea" rows=4 placeholder="Enter the text..." autofocus="true"/>`;
        break;
      case "NUMBER":
        divInput.innerHTML =`<input type="number" id="" name="" min="1" max="10000">`;
        break;
    }

    const offset = this.util.getOffset(selectionSpanTag, this.context.element.wysiwygFrame);
    fsBtn.style.top = (offset.top + selectionSpanTag.offsetHeight + 10) + "px";
    fsBtn.style.left = (offset.left - this.context.element.wysiwygFrame.scrollLeft) + "px";

    fsBtn.style.display = "block";

    const overLeft = this.context.element.wysiwygFrame.offsetWidth - (fsBtn.offsetLeft + fsBtn.offsetWidth);
    if (overLeft < 0) {
      fsBtn.style.left = (fsBtn.offsetLeft + overLeft) + "px";
      fsBtn.firstElementChild.style.left = (20 - overLeft) + "px";
    } else {
      fsBtn.firstElementChild.style.left = "20px";
    }

    selectionSpanTag.textContent
    // Show controller at editor area (controller elements, function, "controller target element(@Required)", "controller name(@Required)", etc..)
    this.controllersOn(fsBtn, selectionSpanTag, "customFillFreeSection");
  },

  onClick_fsButtonController: function (e) {
    const contextFreeSection = this.context.customFillFreeSection;
    const divInput = contextFreeSection.fsController.querySelector(".content-input");
    const datepicker = divInput.querySelector(".react-datepicker__input-container");
    let fsFillValue = "";

    if (contextFreeSection._freeSectionSpan.getAttribute("data-format") === "DATE") {
      fsFillValue = datepicker.children[0].value;
    }  else {
      fsFillValue = divInput.children[0].value;
    }
    contextFreeSection._freeSectionSpan.textContent = fsFillValue;
    contextFreeSection._freeSectionSpan.removeAttribute("style");
    contextFreeSection.fsController.style.display = "none";
  },


  // @Required, @Override dialog
  // This method is called when the dialog window is closed.
  // Initialize the properties.
  init: function () {
    const contextFreeSection = this.context.customFillFreeSection;
    contextFreeSection.fsController.style.display = "none";
    contextFreeSection._freeSectionSpan = null;
  }
};
